import { useParams, Link } from 'react-router-dom'
import { useGetModel } from '../../../../../api/routes/models'
import { authClient, hasPermission } from '../../../../../lib/auth-client'
import { ArrowLeft } from 'lucide-react'
import { ConfigTemplatesSection } from '../config-templates-section'

export const ModelConfigTemplatesRoute = () => {
    const { id: modelId } = useParams<{ id: string }>()
    const { data: model, isLoading } = useGetModel(modelId!)

    const { data: session } = authClient.useSession()
    const role = (session?.user as any)?.role
    const canConfigure = role && hasPermission(role, { model: ['configure'] })

    if (isLoading) {
        return (
            <div className="mx-auto py-6 lg:py-10 px-4 sm:px-6 lg:px-8 xl:px-32">
                Loading...
            </div>
        )
    }

    if (!model) {
        return (
            <div className="mx-auto py-6 lg:py-10 px-4 sm:px-6 lg:px-8 xl:px-32">
                Model not found.
            </div>
        )
    }

    return (
        <div className="mx-auto py-6 lg:py-10 px-4 sm:px-6 lg:px-8 xl:px-32">
            <div className="mb-6">
                <Link
                    to={`/models/${modelId}`}
                    className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors mb-4"
                >
                    <ArrowLeft className="h-4 w-4" />
                    Back to {model.name}
                </Link>
            </div>
            <ConfigTemplatesSection modelId={modelId!} canConfigure={!!canConfigure} />
        </div>
    )
}
